<template>
	<div class="main">
		<div class="p-banner" :style="'background-image: url('+banner+');'"></div>
		<div class="proList-box mb20">
			<div class="container">
				<div class="left-box">
					<div class="pro-menu">
						<ul>
							<li>
								<span>编织工艺</span>
								<ul>
									<li :class="{active:curr_product==products.product_1_fkw}">
										<a href="javascript:;" @click="changeProduct(products.product_1_fkw)">方孔网</a>
									</li>
									<li :class="{active:curr_product==products.product_2_yhw}">
										<a href="javascript:;" @click="changeProduct(products.product_2_yhw)">轧花网</a>
									</li>
									<li :class="{active:curr_product==products.product_3_xxw}">
										<a href="javascript:;" @click="changeProduct(products.product_3_xxw)">席型网</a>
									</li>
									<li :class="{active:curr_product==products.product_4_fcw}">
										<a href="javascript:;"  @click="changeProduct(products.product_4_fcw)">反差网</a>
									</li>
									<li :class="{active:curr_product==products.product_5_sjg}">
										<a href="javascript:;" @click="changeProduct(products.product_5_sjg)">丝网深加工</a>
									</li>
									<li :class="{active:curr_product==products.product_6_cs}">
										<a href="javascript:;" @click="changeProduct(products.product_6_cs)">不锈钢窗纱</a>
									</li>
									<li :class="{active:curr_product==products.product_7_jgw}">
										<a href="javascript:;" @click="changeProduct(products.product_7_jgw)">金刚网</a>
									</li>
									<li :class="{active:curr_product==products.product_8_sw}">
										<a href="javascript:;" @click="changeProduct(products.product_8_sw)">绳网</a>
									</li>
								</ul>
							</li>
							<li>
								<span>焊接工艺</span>
								<ul>
									<li :class="{active:curr_product==products.product_9_dhw}">
										<a href="javascript:;" @click="changeProduct(products.product_9_dhw)">电焊网</a>
									</li>
									
								</ul>
							</li>
							<li>
								<span>冲压工艺</span>
								<ul>
									<li :class="{active:curr_product==products.product_10_ckw}">
										<a href="javascript:;" @click="changeProduct(products.product_10_ckw)">冲孔网</a>
									</li>
									
								</ul>
							</li>
							<li>
								<span>拉伸工艺</span>
								<ul>
									<li :class="{active:curr_product==products.product_11_gbw}">
										<a href="javascript:;" @click="changeProduct(products.product_11_gbw)">钢/铝板网</a>
									</li>
									
								</ul>
							</li>
							<li>
								<span>防护/装饰网</span>
								<ul>
									<li :class="{active:curr_product==products.product_12_zsw}">
										<a href="javascript:;" @click="changeProduct(products.product_12_zsw)">装饰网</a>
									</li>
								</ul>
							</li>
						</ul>
					</div>
				</div>
				<div class="rig-box">
					<component :is="curr_product"></component>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import banner from "../assets/img/pro_banner.jpg";
	import mesh_data from "../assets/data/mesh_data"
	
	import product_1_fkw from "./product_1_fkw";
	import product_2_yhw from "./product_2_yhw";
	import product_3_xxw from "./product_3_xxw";
	import product_4_fcw from "./product_4_fcw";
	import product_5_sjg from "./product_5_sjg";
	import product_6_cs from "./product_6_cs";
	import product_7_jgw from "./product_7_jgw";
	import product_8_sw from "./product_8_sw";
	import product_9_dhw from "./product_9_dhw";
	import product_10_ckw from "./product_10_ckw";
	import product_11_gbw from "./product_11_gbw";
	import product_12_zsw from "./product_12_zsw";
	

	export default {
		name: 'Products',
		data: function () {
			return {
				banner: banner,
				mesh_data: mesh_data,
				products:{
					product_1_fkw:product_1_fkw,
					product_2_yhw:product_2_yhw,
					product_3_xxw:product_3_xxw,
					product_4_fcw:product_4_fcw,
					product_5_sjg:product_5_sjg,
					product_6_cs:product_6_cs,
					product_7_jgw:product_7_jgw,
					product_8_sw:product_8_sw,
					product_9_dhw:product_9_dhw,
					product_10_ckw:product_10_ckw,
					product_11_gbw:product_11_gbw,
					product_12_zsw:product_12_zsw
				},
				curr_product:product_1_fkw
			}
		},
		mounted: function () {
			let select_index = sessionStorage.getItem("__selected_category__")
			let kid = false
			if(select_index)
			{
				for(let k in this.products)
				{
					if(k.indexOf('_'+select_index+'_')>=0)
					{
						this.changeProduct(this.products[k])
						kid = true
						break
					}
				}
			}
			if(!kid)
			{
				this.changeProduct(this.products['product_1_fkw'])
			}
			
			setTimeout(()=>{
				this.backtop()
			},50)
		},
		created: function () {
			
		},
		methods: {
			changeProduct: function (product) {
				this.curr_product = product
			},
			backtop:function(){
				let timer = setInterval(function(){
					let osTop = document.documentElement.scrollTop || document.body.scrollTop;
					let ispeed = Math.floor(-osTop/5)
					console.info(ispeed)
					document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
			
					if(osTop===0)
					{
						clearInterval(timer)
					}
				},30)
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/productDetail.vue